import React, { useEffect, useContext } from "react";
import Header from "components/Header";
import { useNavigate } from "react-router-dom";
import { userContext } from "contextProviders/userContext";
import LetterForm from "components/Forms/LetterForm";
import imgBg from "img/bg_2.png";
import imgGiftFront from "img/gift_1.png";
import imgGiftBack from "img/gift_2.png";

const LetterPage = () => {
  const navigate = useNavigate();
  const { user } = useContext(userContext);

  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user, navigate]);

  return (
    <section class="main data">
      <div class="main-bg">
        <img src={imgBg} alt="#" />
      </div>

      <div className="main-gift-front">
        <img src={imgGiftFront} alt="#" />
      </div>

      <div className="main-gift-back">
        <img src={imgGiftBack} alt="#" />
      </div>

      <LetterForm />
    </section>
  );
};

export default LetterPage;
